var React = require('react');

function SignalAlt3Solid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"}));
}

SignalAlt3Solid.defaultProps = {"viewBox":"0 0 640 512"};

module.exports = SignalAlt3Solid;

SignalAlt3Solid.default = SignalAlt3Solid;
